module.exports = __webpack_public_path__ + "static/media/ahmad_jawhari_f.38187e44.jpg";